<template>
  <zen-one :showuserinfo="false" :title="'Welcome to ' + $page.props.app_name">
        <w-flex justify-center style="background-image:url('images/background/rainbow.jpg');background-size: cover;height:150vh;opacity: 0.5;">
            
            <w-image  class="d-block mt8" :src="`images/logok.png`" :width="72" :height="72"></w-image>
            <div class="box ml2 mt8">
              <h1 class="mt3 blue-dark4">Selamat Datang {{ $page.props.auth.user.name }} </h1>
              <span class="brown-dark1">Log masuk terakhir anda adalah pada </span> 
              <span class="box-date brown-dark1">{{ $zutil.dateformat($page.props.auth.user.updated_at) }} </span>
          </div>
        </w-flex>

     

  </zen-one>
</template>

<script>


import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs
},
  setup () {
    

    const doughnutChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['2020', '2021'],
        datasets: [
          {
            borderColor: "#7983ff",
            backgroundColor: "#8bb4fa",
            data: [64.74, 94.63]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }

    const monthlyChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['Januari', 'Febuari', 'Mac', 'April', 'May', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'],
        datasets: [{
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }, {
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }]
      },
      options: { plugins: { legend: { display: false }, } }

    }

    const daylyChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['Kota Setar', 'Kuala Muda', 'Kubang Pasu', 'Langkawi', 'Kulim', 'Sik', 'Yan', 'Padang Terap', 'Bandar Baharu', 'Baling', 'Pendang', 'Pokok Sena'],
        datasets: [{
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }, {
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }]
      },
      options: { plugins: { legend: { display: false }, } }

    }
    
    const transactionmethoddaylyChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['Kaunter', 'Portal iBayaq', 'Aplikasi Mobile'],
        datasets: [
          {
            borderColor: "#7983ff",
            backgroundColor: "#8bb4fa",
            data: [1000, 2050, 3000]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }
  
    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}   
    }    

    return {
      doughnutChart,
      monthlyChart,
      transactionmethoddaylyChart,
      daylyChart,
      beforeRenderLogic
    }
  },
data() {
    return {
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
  showCard: false,
  params : {}
}},
methods: {
  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
},
  mounted() {
    
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.l == 1){
      window.location.replace(window.location.pathname);
    }
}
}

</script>

<style>
.dashboard-box .w-image {
    background-size: contain;
}
.zdiimage {
    margin-right: 7px;
}
.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}
.dashboard-percentage {
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 20px;
}
.dashboard-percentage-no {
    font-size: 20px;
}
.dashboard-more {
    position: absolute;
    right: 20px;
    top: 30px;
    color: #fff;
    background: #1f2248;
    padding: 3px 15px;
    border-radius: 5px;
    border: none;
}
</style>